import React, { ComponentProps } from 'react'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import LuxuryPlusLabeledContainer from './LuxuryPlusLabeledContainer'
import LuxuryPlusLabel from './LuxuryPlusLabel'
import PriceRowPriceWithCaption from 'components/Luxkit/PricePoints/PriceRowPriceWithCaption'
import Group from 'components/utils/Group'
import styled from 'styled-components'
import cn from 'clsx'

interface Props extends ComponentProps<typeof PriceRowPrice> {
  memberPrice: number;
  align?: 'start' | 'center' | 'end';
}

const GroupAlignContainer = styled(Group)`
  &.align-start {
    text-align: start;
  }

  &.align-center {
    text-align: center;
  }

  &.align-end {
    text-align: end;
  }
`

function LuxuryPlusPrice(props: Props) {
  const { memberPrice, saleUnit, taxesAndFees, price, size, 'data-testid': TestId, align = 'start' } = props

  return <GroupAlignContainer direction="vertical" gap={4} horizontalAlign={align} className={cn(`align-${align}`)}>
    <LuxuryPlusLabeledContainer
    size="small"
    labels={
      <LuxuryPlusLabel type="only-logo" size="small" />
    }>
      <PriceRowPrice
          size={size}
          price={memberPrice}
          saleUnit={saleUnit}
          data-testid={TestId}
          taxesAndFees={taxesAndFees}
        />
    </LuxuryPlusLabeledContainer>
    <PriceRowPriceWithCaption
      caption="Non-member"
      taxesAndFees={taxesAndFees}
      price={price}
      saleUnit=""
      size="S"
    />
  </GroupAlignContainer>
}

export default LuxuryPlusPrice
